import type { UserState } from './types'

export const selectUser = (state: { user: UserState }) => state.user
